<!-- Requirement: Zone restriction UX — shown when the backend rejects an update
     because the report belongs to a parent zone. The form is also disabled so the
     user cannot accidentally retry a mutation that will always fail until they
     switch to the correct zone. -->
<p-message
    *ngIf="notEditable"
    severity="warn"
    styleClass="p-mb-3 full-width"
    [text]="notEditableReason"
></p-message>

<div [formGroup]="dynamicReportForm">
    <ng-template #name>
        <input
            type="text"
            pInputText
            formControlName="name"
            placeholder="Name"
        />
    </ng-template>
    <ng-template #description>
        <textarea
            placeholder="Description (optional)"
            pInputTextarea
            formControlName="description"
            class="full-width"
        ></textarea>
        <small class="p-text-secondary">Leave blank to have AI auto-generate a description.</small>
    </ng-template>
    <!-- Requirement: Feature 2 (Issue #5821) — Path/folder field so users can organise
         reports into folders. Pre-filled with the folder the user is currently browsing. -->
    <ng-template #path>
        <label class="p-mb-1 p-d-block">Folder Path</label>
        <p-autoComplete
            formControlName="path"
            [suggestions]="filteredPaths"
            (completeMethod)="filterPaths($event)"
            placeholder="/ (root)"
            [forceSelection]="false"
            styleClass="full-width"
            appendTo="body"
        ></p-autoComplete>
        <small class="p-text-secondary p-mt-1 p-d-block">
            Use <code>/Folder/Subfolder</code> format. Leave as <code>/</code> for the root.
        </small>
    </ng-template>
</div>
<app-mutate-object
    #mutate
    [fg]="dynamicReportForm"
    objectType="Revenue Report"
    [mutateType]="mutateType"
    [steps]="steps"
    (objectMutated)="mutateObject()"
></app-mutate-object>
